var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0C6.24563 0 4.08367 0.895529 2.48963 2.48963C0.895529 4.08361 0 6.24569 0 8.5C0 10.7543 0.895529 12.9163 2.48963 14.5104C4.08361 16.1045 6.24569 17 8.5 17C10.7543 17 12.9163 16.1045 14.5104 14.5104C16.1045 12.9164 17 10.7543 17 8.5C17 6.24569 16.1045 4.08367 14.5104 2.48963C12.9164 0.895529 10.7543 0 8.5 0ZM8.5 15.5831C6.62142 15.5831 4.81983 14.8369 3.49141 13.5085C2.16305 12.1802 1.41682 10.3784 1.41682 8.49994C1.41682 6.62145 2.16305 4.81977 3.49141 3.49135C4.81977 2.16299 6.62151 1.41676 8.5 1.41676C10.3785 1.41676 12.1802 2.16299 13.5086 3.49135C14.8369 4.81971 15.5832 6.62145 15.5832 8.49994C15.5812 10.3779 14.8342 12.1783 13.5063 13.5064C12.1783 14.8343 10.3781 15.5812 8.49988 15.5832L8.5 15.5831Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49806 3.92902C5.96493 4.45908 5.66598 5.18042 5.66798 5.93221H7.08468H7.08456C7.08361 5.5563 7.23302 5.19557 7.49972 4.93055C7.76949 4.67287 8.1282 4.52902 8.50126 4.52902C8.87431 4.52902 9.23301 4.67286 9.50279 4.93055C9.76948 5.19558 9.91889 5.5563 9.91795 5.93221C9.91439 6.32767 9.75028 6.70476 9.4632 6.97691L8.87671 7.66896C8.17719 8.49512 7.79324 9.54244 7.793 10.6248H9.20969H9.20958C9.20993 9.87779 9.47496 9.15502 9.9576 8.58489L10.5044 7.93531H10.5045C11.0356 7.40407 11.334 6.68345 11.334 5.93224C11.334 5.18091 11.0356 4.46042 10.5045 3.92905C9.96449 3.41465 9.24718 3.12769 8.50132 3.12769C7.75545 3.12769 7.03814 3.41465 6.49812 3.92905L6.49806 3.92902Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79297 12.0417H9.20967V13.4584H7.79297V12.0417Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoTooltip);
export default __webpack_public_path__ + "static/media/infoTooltip.e3fce7e93cb84f008c1829b09933a699.svg";
export { ForwardRef as ReactComponent };